import arc from './helpers/quarter-arc.js'
import { path } from 'd3-path'
import pointer from './helpers/pointer.js'
import CurvedArrow from './curved-arrow.js'

export default class LeftCurvedArrow extends CurvedArrow {

  handles = [{
    // first handle: x controls the arrow height, y controls the arrow width
    defaults: [.38, .13],
    constraints: (dimensions, handles) => {
      const x1 = handles[1].coords[0] // Can't be greater than the radius
      const x2 = dimensions.height / dimensions.width // Cannot create an arrow head height that is greater than height
      const x3 = Math.max(0, 1 - ((handles[0].coords[1] * dimensions.height * 2) / dimensions.width))
      const maxX = Math.min(x1, x2, x3)

      const maxY = Math.min(.25, dimensions.width / dimensions.height / 2)

      return [
        [0, maxX], [.001, maxY]
      ]
    },
    cursor: 'all-scroll',
  }, {
    // second handle: x controls the radius
    defaults: [0.6, null],
    constraints: (dimensions, handles) => {
      // The x constraint is related to the maximum radius
      const maxHeight = dimensions.height - dimensions.height * handles[0].coords[1]
      const minWidth = dimensions.width - dimensions.width * handles[0].coords[0]

      return [
        [1 - Math.min(maxHeight, minWidth) / dimensions.width, 1], null
      ]
    },
    cursor: 'ew-resize',
  }]

  updateHandles (handles, dimensions) {
    // Make sure the handle positions are correct
    handles[0][0] = this.properties.tipHeight / dimensions.width
    handles[0][1] = this.properties.tipWidth / (dimensions.height * 2)
    handles[1][0] = 1 - (this.properties.radius / dimensions.width)
  }

  getProperties (dimensions, handles) {
    return {
      tipHeight: handles[0][0] * dimensions.width,
      tipWidth: dimensions.height * handles[0][1] * 2,
      radius: Math.max(0, dimensions.width - handles[1][0] * dimensions.width)
    }
  }

  path (dimensions, handles) {
    const _path = path()

    const _pointer = pointer(_path, dimensions, handles[0], {
      width: this.properties.tipWidth,
      height: this.properties.tipHeight
    })

    const innerRadius = Math.max(0, this.properties.radius - _pointer.width)

    // Build the top left facing arrow
    _path.moveTo(_pointer.height, _pointer.width + _pointer.width / 2)
    _pointer([_pointer.height, _pointer.width + _pointer.width / 2], 'west')

    // Move to the start of the outer curve
    _path.lineTo(dimensions.width - this.properties.radius,  _pointer.width / 2)

    arc(_path, [dimensions.width - this.properties.radius, _pointer.width / 2 + this.properties.radius], this.properties.radius, 3 * Math.PI / 2)

    // Draw the base of the arrow
    _path.lineTo(dimensions.width, dimensions.height)
    _path.lineTo(dimensions.width - _pointer.width, dimensions.height)
    _path.lineTo(dimensions.width - _pointer.width, innerRadius + _pointer.width + _pointer.width / 2)

    arc(_path, [
      dimensions.width - (_pointer.width + innerRadius),
      _pointer.width / 2 + _pointer.width + innerRadius],
      innerRadius, 0, false)
    _path.closePath()

    return _path.toString()
  }

}
